import { Link } from 'react-router-dom'
export default function NotFound() {
  return (
    <div className="section max-w-md text-center">
      <div className="font-display text-8xl text-civitas-gold font-bold mb-4">404</div>
      <h1 className="font-display text-2xl text-civitas-navy mb-3">Page not found</h1>
      <p className="text-civitas-silver mb-6">The page you&apos;re looking for doesn&apos;t exist. It may have moved or the URL may be incorrect.</p>
      <div className="flex gap-3 justify-center">
        <Link to="/" className="btn-primary">Go Home</Link>
        <Link to="/candidates" className="btn-secondary">Browse Candidates</Link>
      </div>
    </div>
  )
}
